import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { MetaType } from "core/enums";
import { AttributeTextField } from "components/CaseManagement/CaseDetail/MetaDataTable/AttributeTextField";
import { AttributeNumericField } from "components/CaseManagement/CaseDetail/MetaDataTable/AttributeNumericField";
import { AttributeCategoryField } from "components/CaseManagement/CaseDetail/MetaDataTable/AttributeCategoryField";
import { AttributeDateField } from "components/CaseManagement/CaseDetail/MetaDataTable/AttributeDateField";

export const NO_VALUE_ERROR = "You must enter a value";

export function MetaDataEditField({
  attributeName,
  attributeDataType,
  categoricalValues,
  attributeFieldValue,
  setAttributeFieldValue,
  setValidationError,
  enableLabel,
  inputAdornment,
  size,
  dense
}) {
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    setErrorMessage("");
    setValidationError(false);
  }, [setValidationError]);

  const handleError = message => {
    setValidationError(true);
    setErrorMessage(message);
  };

  const handleClearError = () => {
    setValidationError(false);
    setErrorMessage(undefined);
  };

  switch (attributeDataType.id) {
    case MetaType.CATEGORY:
      return (
        <AttributeCategoryField
          categoricalValues={categoricalValues}
          value={attributeFieldValue}
          onChangeValue={setAttributeFieldValue}
          error={errorMessage}
          enableLabel={enableLabel}
          size={size}
          dense={dense}
          placeHolder={attributeName}
          inputAdornment={inputAdornment}
        />
      );
    case MetaType.DATE:
      return (
        <AttributeDateField
          value={attributeFieldValue}
          enableLabel={enableLabel}
          onChangeValue={setAttributeFieldValue}
          size={size}
          dense={dense}
          placeholder={attributeName}
          inputAdornment={inputAdornment}
        />
      );
    case MetaType.NUMBER:
      return (
        <AttributeNumericField
          value={attributeFieldValue}
          onChangeValue={setAttributeFieldValue}
          error={errorMessage}
          onError={handleError}
          onClearError={handleClearError}
          enableLabel={enableLabel}
          size={size}
          dense={dense}
          placeHolder={attributeName}
          inputAdornment={inputAdornment}
        />
      );
    case MetaType.TEXT:
      return (
        <AttributeTextField
          value={attributeFieldValue}
          onChangeValue={value => setAttributeFieldValue(value)}
          error={errorMessage}
          onError={handleError}
          onClearError={handleClearError}
          enableLabel={enableLabel}
          size={size}
          dense={dense}
          placeHolder={attributeName}
          inputAdornment={inputAdornment}
        />
      );
    default:
      console.error(`unhandled attribute type ${attributeDataType?.id}`);
      return <></>;
  }
}

MetaDataEditField.propTypes = {
  attributeName: PropTypes.string,
  attributeFieldValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date)
  ]),
  attributeDataType: PropTypes.object,
  categoricalValues: PropTypes.array,
  setAttributeFieldValue: PropTypes.func,
  setValidationError: PropTypes.func,
  enableLabel: PropTypes.bool,
  size: PropTypes.string,
  dense: PropTypes.bool,
  inputAdornment: PropTypes.node
};

MetaDataEditField.defaultProps = {
  enableLabel: true
};
